import { render, staticRenderFns } from "./render-sort-column.vue?vue&type=template&id=08f64efa&scoped=true"
import script from "./render-sort-column.vue?vue&type=script&lang=js"
export * from "./render-sort-column.vue?vue&type=script&lang=js"
import style0 from "./render-sort-column.vue?vue&type=style&index=0&id=08f64efa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f64efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f64efa')) {
      api.createRecord('08f64efa', component.options)
    } else {
      api.reload('08f64efa', component.options)
    }
    module.hot.accept("./render-sort-column.vue?vue&type=template&id=08f64efa&scoped=true", function () {
      api.rerender('08f64efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-sort-column.vue"
export default component.exports